import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import {_} from '../../../js/globals';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
@Component({
    standalone: false,
    selector: 'benchmarking',
    templateUrl: '../app/pages/benchmarking/benchmarking.view.html',
    styleUrls: ['../app/pages/benchmarking/benchmarking.style.css']
})
export class Benchmarking implements OnInit, OnDestroy {

    private herdChangeSubscription: any;

    _: any;
    loading: boolean = true;
    appLoaded: boolean = false;
    currentActiveHerdId: number;
    shinyAppHasError: boolean = false;
    shinyAppUrl: string = "";
    //shinyAppUrl: string = "https://parnell.shinyapps.io/MySYNCH_Benchmarks/";
    shinyAppName: string = "Benchmarking Shiny App";
    shinyAppMinHeight: number = 600;
    constructor(@Inject('MySynchFactory') private MSF: any,
                @Inject(MySynchConstantService) private MSCS: MySynchConstantService,
                @Inject(MySynchDataStore) private mysynchDataStore: MySynchDataStore) {
        this._ = _;
         var environmentName = this.MSF.getEnvironmentName().toLowerCase();
        var shinyServerBaseSubdomain = this.MSCS.shinyServerBaseSubdomain;
        var shinyServerBaseDomain = this.MSCS.shinyServerBaseDomain;
        if(!_.isEqual(environmentName, "local")){
           this.shinyAppUrl = `https://${shinyServerBaseSubdomain}${environmentName}.${shinyServerBaseDomain}/MySYNCH_Benchmarks/`;
          
        }else{
          this.shinyAppUrl = `https://${shinyServerBaseSubdomain}dev.${shinyServerBaseDomain}/MySYNCH_Benchmarks/`;
        }
    }

    onShinyAppLoaded() {
        console.log('Shiny app has loaded successfully.');
        this.appLoaded = true;
    }

    onShinyAppError(errorMessage: string) {
        console.error('Shiny app failed to load with error:', errorMessage);
        this.appLoaded = false;
        this.shinyAppHasError = true;
    }

    ngOnInit() {
        this.MSF.ready(() => {
            this.currentActiveHerdId = _.get(this.MSF.getActiveHerd(), 'herdId');
            this.herdChangeSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd)=>{
                if(!_.isUndefined(herd) && this.loading === false){
                    this.currentActiveHerdId = _.get(herd, 'herdId');
                }
            });
            this.loading = false;
        });
    }

    ngOnDestroy() {
        // Cleanup logic here
        this.onShinyAppLoaded = null;
        this.onShinyAppError = null;
        
        if(this.herdChangeSubscription){
            this.herdChangeSubscription.unsubscribe();
        }
    }
}
